
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';
import React from 'react';
import App from './App';
import './index.scss';

// import * as serviceWorker from './serviceWorker';
import { ApolloClient, InMemoryCache, ApolloProvider} from "@apollo/client";

const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
const rootElement = document.getElementById('root');
const root = createRoot(rootElement);
// const link = createHttpLink({
//   uri: '/graphql',
//   // credentials: 'same-origin'
// });
const client = new ApolloClient({
    uri:  '/api/graphql',
    cache: new InMemoryCache()
});
root.render(
    <ApolloProvider client={client}>
      <BrowserRouter basename={baseUrl}>
      <App />
      </BrowserRouter>
    </ApolloProvider>);

 serviceWorkerRegistration.unregister();
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
reportWebVitals();
